import { I18N } from '@element451-libs/models451';
import { Translation } from '@jsverse/transloco';

export const translationsLoader = I18N.SupportedLangs.reduce((acc, lang) => {
  acc[lang] = () => import(`./${lang}.json`);
  return acc;
}, {} as Record<string, () => Promise<Translation>>);
